const subscribersActions = {
  FETCH_SUBSCRIBERS: 'FETCH_SUBSCRIBERS',
  REFRESH_SUBSCRIBERS: 'REFRESH_SUBSCRIBERS',
  SHOW_SUBSCRIBERS: 'SHOW_SUBSCRIBERS',
  SHOW_SUBSCRIBERS_ERROR: 'SHOW_SUBSCRIBERS_ERROR',
  CLOSE_SUBSCRIBERS: 'CLOSE_SUBSCRIBERS',
  UPDATE_SUBSCRIBERS_FILTER: 'UPDATE_SUBSCRIBERS_FILTER',
  UPDATE_SUBSCRIBERS_ROLE_FILTER: 'UPDATE_SUBSCRIBERS_ROLE_FILTER',
};

export const datasetSubscriptions = {
  DATASET_UPDATE: 'dataset-update',
};

const subscribersIcons = {
  dataset: 'table',
};

export const subscribersIcon = (entity) => subscribersIcons[entity] || 'users';

export default subscribersActions;
